import { render, staticRenderFns } from "./GetPicaHeader.vue?vue&type=template&id=11c245a5&scoped=true"
import script from "./GetPicaHeader.vue?vue&type=script&lang=js"
export * from "./GetPicaHeader.vue?vue&type=script&lang=js"
import style0 from "./GetPicaHeader.vue?vue&type=style&index=0&id=11c245a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c245a5",
  null
  
)

export default component.exports